import {
    useGetFlashInfoMutation,
    usePostFlashInfoMutation,
    usePutFlashInfoMutation
} from '@services/member/flash-info/flash-info.endpoints';
import { FlashInfoToCreate } from '@services/member/flash-info/flash-info.types';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const useAddPageVM = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    const [flashInfo, setFlashInfo] = useState<FlashInfoToCreate>();

    const [
        getFlashInfo,
        {
            isLoading: isGetFlashInfoLoading,
            isError: isGetFlashInfoError,
            error: getFlashInfoError,
            isSuccess: isGetFlashInfoSuccess,
            data: getFlashInfoResponse
        }
    ] = useGetFlashInfoMutation();

    const [
        createFlashInfo,
        {
            isLoading: isCreateFlashInfoLoading,
            isError: isCreateFlashInfoError,
            isSuccess: isCreateFlashInfoSuccess,
            error: createFlashInfoError,
            data: createFlashInfoResponse
        }
    ] = usePostFlashInfoMutation();

    const [
        updateFlashInfo,
        {
            isLoading: isUpdateFlashInfoLoading,
            isError: isUpdateFlashInfoError,
            error: updateFlashInfoError,
            isSuccess: isUpdateFlashInfoSuccess,
            data: updateFlashInfoResponse
        }
    ] = usePutFlashInfoMutation();

    useEffect(() => {
        if (!id) return;
        getFlashInfo({ id });
    }, [id]);

    useEffect(() => {
        if (isUpdateFlashInfoLoading) return;
        if (isUpdateFlashInfoError) return;
        if (updateFlashInfoError) return;

        if (isUpdateFlashInfoSuccess && updateFlashInfoResponse) {
            navigate(`/members-management/flash-infos`);
        }
    }, [
        isUpdateFlashInfoError,
        isUpdateFlashInfoSuccess,
        updateFlashInfoError,
        updateFlashInfoResponse,
        isUpdateFlashInfoLoading,
        navigate
    ]);

    useEffect(() => {
        if (isCreateFlashInfoLoading) return;
        if (isCreateFlashInfoError) return;
        if (createFlashInfoError) return;

        if (isCreateFlashInfoSuccess && createFlashInfoResponse) {
            navigate(`/members-management/flash-infos`);
        }
    }, [isCreateFlashInfoError, isCreateFlashInfoSuccess, createFlashInfoError, createFlashInfoResponse, isCreateFlashInfoLoading, navigate]);

    useEffect(() => {
        if (isGetFlashInfoLoading) return;
        if (isGetFlashInfoError) return;
        if (getFlashInfoError) return;

        if (isGetFlashInfoSuccess && getFlashInfoResponse) {
            setFlashInfo(getFlashInfoResponse.data);
        }
    }, [isGetFlashInfoError, isGetFlashInfoSuccess, getFlashInfoError, getFlashInfoResponse, isGetFlashInfoLoading]);

    const submitForm = async (values: FlashInfoToCreate) => {
        if (flashInfo && id) {
            await updateFlashInfo({ id: id, flashInfo: values });
        } else {
            await createFlashInfo(values);
        }
    };

    return {
        flashInfo,
        isEdit: !!id,
        submitForm,
        isLoading: isCreateFlashInfoLoading || isGetFlashInfoLoading || isUpdateFlashInfoLoading
    };
};
